import React from "react";
import "./Skeletons.css";

// Reusable navbar skeleton - matches actual Navbar dimensions
const NavbarSkeleton = () => (
  <div className="skeleton-navbar">
    <div className="skeleton skeleton-logo"></div>
    <div className="skeleton skeleton-avatar"></div>
  </div>
);

// Dashboard content skeleton (NO navbar - use when real navbar is already shown)
export const DashboardContentSkeleton = () => (
  <div className="dashboard-content">
    <div className="dashboard-view">
      <div className="skeleton skeleton-page-title"></div>
      <div className="skeleton skeleton-page-subtitle"></div>
      <div className="row">
        {[1, 2, 3].map((i) => (
          <div key={i} className="col-sm-4 folio-container">
            <div className="skeleton-card">
              <div className="skeleton skeleton-card-image"></div>
              <div className="skeleton skeleton-card-title"></div>
              <div className="skeleton skeleton-card-subtitle"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

// FolioForm content skeleton (NO navbar - use when real navbar is already shown)
// Matches actual layout: 3-column grid (tabs | form content | spacer)
export const FolioFormContentSkeleton = () => (
  <div className="skeleton-folioform">
    <div className="skeleton-folioform-row">
      {/* Left side: Vertical tabs card */}
      <div className="skeleton-folioform-tabs-container">
        <div className="skeleton-vertical-tabs">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="skeleton-tab-item">
              <div className="skeleton skeleton-tab-text"></div>
            </div>
          ))}
        </div>
      </div>
      {/* Middle: Form content */}
      <div className="skeleton-folioform-content">
        <div className="skeleton skeleton-form-title"></div>
        <div className="skeleton skeleton-form-description"></div>
        <div className="skeleton-form-group">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input"></div>
        </div>
        <div className="skeleton-form-group">
          <div className="skeleton skeleton-label"></div>
          <div className="skeleton skeleton-input"></div>
        </div>
        <div className="skeleton skeleton-button"></div>
      </div>
      {/* Right side: Spacer for balance (hidden on smaller screens via CSS) */}
      <div className="skeleton-folioform-spacer" aria-hidden="true" />
    </div>
  </div>
);

// Dashboard skeleton - navbar + card grid (for Suspense fallback)
export const DashboardSkeleton = () => (
  <div className="skeleton-page">
    <NavbarSkeleton />
    <DashboardContentSkeleton />
  </div>
);

// Form skeleton - navbar + tabs + form fields
export const FormSkeleton = () => (
  <div className="skeleton-page">
    <NavbarSkeleton />
    <div className="skeleton-form-content">
      <div className="skeleton-tabs">
        <div className="skeleton skeleton-tab"></div>
        <div className="skeleton skeleton-tab"></div>
        <div className="skeleton skeleton-tab"></div>
        <div className="skeleton skeleton-tab"></div>
      </div>
      <div className="skeleton-form-group">
        <div className="skeleton skeleton-label"></div>
        <div className="skeleton skeleton-input"></div>
      </div>
      <div className="skeleton-form-group">
        <div className="skeleton skeleton-label"></div>
        <div className="skeleton skeleton-input"></div>
      </div>
      <div className="skeleton-form-group">
        <div className="skeleton skeleton-label"></div>
        <div className="skeleton skeleton-textarea"></div>
      </div>
      <div className="skeleton skeleton-button"></div>
    </div>
  </div>
);

// Billing skeleton - navbar + plan card
export const BillingSkeleton = () => (
  <div className="skeleton-page">
    <NavbarSkeleton />
    <div className="skeleton-billing-content">
      <div className="skeleton skeleton-page-title"></div>
      <div className="skeleton-plan-card">
        <div className="skeleton skeleton-plan-title"></div>
        <div className="skeleton skeleton-plan-price"></div>
        <div className="skeleton-plan-features">
          <div className="skeleton skeleton-feature"></div>
          <div className="skeleton skeleton-feature"></div>
          <div className="skeleton skeleton-feature"></div>
          <div className="skeleton skeleton-feature"></div>
        </div>
        <div className="skeleton skeleton-button"></div>
      </div>
    </div>
  </div>
);

// Generic page skeleton for other pages
export const PageSkeleton = () => (
  <div className="skeleton-page">
    <NavbarSkeleton />
    <div className="skeleton-form-content">
      <div className="skeleton skeleton-page-title"></div>
      <div className="skeleton-form-group">
        <div className="skeleton skeleton-input"></div>
      </div>
      <div className="skeleton-form-group">
        <div className="skeleton skeleton-input"></div>
      </div>
    </div>
  </div>
);

// User Testing skeleton - sidebar + main content (matches UserTestingLayout)
export const UserTestingSkeleton = () => (
  <div className="skeleton-ut-layout">
    {/* Sidebar */}
    <div className="skeleton-ut-sidebar">
      <div className="skeleton-ut-sidebar-header">
        <div className="skeleton skeleton-ut-logo"></div>
        <div className="skeleton skeleton-ut-logo-text"></div>
      </div>
      <div className="skeleton-ut-sidebar-nav">
        {[1, 2, 3].map((i) => (
          <div key={i} className="skeleton skeleton-ut-nav-item"></div>
        ))}
      </div>
      <div className="skeleton-ut-sidebar-usage">
        <div className="skeleton skeleton-ut-usage-label"></div>
        <div className="skeleton skeleton-ut-usage-bar"></div>
      </div>
    </div>
    {/* Main content */}
    <div className="skeleton-ut-main">
      <div className="skeleton-ut-header">
        <div className="skeleton skeleton-ut-title"></div>
        <div className="skeleton skeleton-ut-subtitle"></div>
      </div>
      <div className="skeleton-ut-stats">
        {[1, 2, 3].map((i) => (
          <div key={i} className="skeleton skeleton-ut-stat-card"></div>
        ))}
      </div>
      <div className="skeleton-ut-content">
        <div className="skeleton skeleton-ut-card"></div>
      </div>
    </div>
  </div>
);

export default DashboardSkeleton;
